import { useEffect, useState } from "react";

/** How long a passing state must last before it is said (the cheatsheet's
 *  "Saving…" rule: shown only if the save lasts). */
export const LASTING_MS = 1000;

/**
 * `true` once `active` has held for `delayMs` without interruption; `false`
 * as soon as it ends. A state that resolves sooner is never shown, so it
 * cannot flash.
 */
export function useLasting(active: boolean, delayMs = LASTING_MS): boolean {
  const [lasting, setLasting] = useState(false);
  useEffect(() => {
    if (!active) {
      setLasting(false);
      return;
    }
    const timer = window.setTimeout(() => setLasting(true), delayMs);
    return () => window.clearTimeout(timer);
  }, [active, delayMs]);
  return active && lasting;
}
